export const enumPermisosGestionItau = Object.freeze({
  BLOQUEOS_CONVENIOS_ITAU: 36001,
  CONVENIOS_ITAU: 36015,
  BLOQUEOS_COMERCIOS_ITAU: 36002,
});

